import React from 'react';
import { format, isValid } from 'date-fns';
import { config } from '@/config';

interface TransactionDateProps {
    date: string | Date;
}

export const TransactionDate = (props: TransactionDateProps) => {
    const date = new Date(props.date);
    return <div>{isValid(date) ? format(date, config.dateFormat) : '-'}</div>;
};
